export default __webpack_public_path__ + "static/media/c9937356d3f67444.9f43c6c9fac0312049dd4c6dc7f6c170.svg";